import React from 'react'

const ReportPage = () => {
  return (
    <div className="main-content container">
    <div className="confirmation-card">
      <h2 className="confirmation-title">Thank You for Your Submission!</h2>
      <p className="confirmation-text">Thank for submitting your details for mobile numerology report.</p>
      <p className="confirmation-text mb-4">
        Please note your report will be sent on your email-id max in 24 - 48 hours depending upon the orders in
        queue.
      </p>
      <button className="cta-button">
        <a href="https://mr.liveluckier.com/10xluckspecial" >Click Here To Checkout More About 10x Luck Report</a>
      </button>
    </div>
  </div>
  )
}

export default ReportPage